import {useEffect} from "react";

const useScrollTop = (deps = []) => {
  useEffect(() => {
    document.body.scrollTop = 0;
  }, [...deps]);
};

export default useScrollTop;
